<template>
  <section class="flex align-middle justify-center sm:py-40">
    <div class="w-full border-box p-24 bg-foreground" style="max-width: 448px; box-shadow: rgba(5, 7, 15, 0.16) 0px 2px 4px 0px">
      <form novalidate @submit.prevent="handleSubmit">
        <h1 class="text-h2 text-m3 pb-12 leading-8 text-center">What’s your home address?</h1>
        <h3 class="text-center text-grey-body mb-24">
          We use it to verify you're a real person, and it will never be shared publicly.
        </h3>
        <AddressAutoComplete ref="addressAutoComplete" :requiredFields="requiredFields" @update:model-value="handleAddress" />
        <Spinner v-if="showLoader" class="m-auto" />
        <PoppinsButton
          id="formSubmit"
          :loading="false"
          class="w-full mt-24"
          variant="primary"
          value="Continue"
          size="medium"
          type="submit"
        />
      </form>
    </div>
  </section>
</template>

<script lang="ts">
import { sendBrazeEvent } from '../../../lib/braze';
import { BASIC_REGISTRATION_LOCATION_LOADED } from '@/lib/constants/braze_custom_events';
import { redirect, replaceRedirect } from '../../../helpers/redirects';
import { UPDATE_PARENT } from '../../../graphql/account/mutations';
import AddressAutoComplete from '@/components/addressAutoComplete/AddressAutoComplete.vue';
import Button from '@/components/button/Button.vue';
import Spinner from '@/components/spinner/Spinner.vue';

export default {
  name: 'Location',
  components: {
    AddressAutoComplete,
    PoppinsButton: Button,
    Spinner,
  },
  data(): any {
    return {
      form: {
        addressLine1: '',
        addressLine2: '',
        city: '',
        stateCode: '',
        postalCode: '',
      },
      requiredFields: ['addressLine1', 'city', 'stateCode', 'postalCode'],
      showLoader: false,
    };
  },
  mounted() {
    sendBrazeEvent(BASIC_REGISTRATION_LOCATION_LOADED);
  },
  methods: {
    handleAddress(addressAutoCompleteFields) {
      Object.keys(this.form).forEach((key) => {
        this.form[key] = addressAutoCompleteFields[key];
      });
    },
    async handleSubmit() {
      if (this.$refs.addressAutoComplete.validateAll()) {
        this.showLoader = true;
        await this.updateParentAddress();
      }
    },
    async updateParentAddress() {
      try {
        await this.$apollo.mutate({
          mutation: UPDATE_PARENT,
          variables: {
            postalAddress: this.form,
          },
          refetchQueries: ['FETCH_PARENT_REGISTRATION'],
        });

        const returnPath = this.$route?.query?.return_path;
        if (typeof returnPath === 'string' && returnPath.length > 0) {
          replaceRedirect(returnPath);
        } else {
          redirect('/account/seekers/dashboard');
        }
      } catch (error) {
        console.error(error);
        this.showLoader = false;
        redirect('/something-went-wrong?retry=true');
      }
    },
  },
};
</script>
